// deps
import React from "react";

// styles
import { CartGroup } from "../styles";

export default function CartGroupContainer(props: {
    children: React.ReactNode;
    className?: string;
    withNoTitle?: boolean;
    hasErrorBorder?: boolean;
    allowOverflow?: boolean;
}): React.ReactElement {
    return (
        <CartGroup
            className={props.className}
            withNoTitle={props.withNoTitle}
            hasErrorBorder={props.hasErrorBorder}
            allowOverflow={props.allowOverflow}
        >
            {props.children}
        </CartGroup>
    );
}
